import React from 'react'
import { NavLink } from 'react-router-dom'

import { useLogout } from '../../hooks/useLogout'

//LOGOS
import cal from '../../assets/icons/cal.svg'
import search from '../../assets/icons/search.svg'
import close from '../../assets/icons/logoutUser.svg'
import contact from '../../assets/icons/contact.svg'
import home from '../../assets/icons/home.svg'

//STYLEs
import './Footer.css'

export default function Footer() {

  const {logout} = useLogout()
  return (
    <footer>
        <nav>
            <NavLink to="/bar/home">
              <img src={home} alt="home" />
            </NavLink>
            <a href="https://shifts.everhour.com">
              <img src={cal} alt="calendar" />
            </a>
            <NavLink to="/bar/contact">
              <img src={contact} alt="contact" />
            </NavLink>
            <a onClick={logout}>
              <img src={close} alt="logout" />
            </a>
        </nav>
    </footer>
  )
}
